import React, { createContext, useContext, useEffect, useState } from "react";
import { api, saveAuth, clearAuth, loadUser } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(loadUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("epc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        clearAuth();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (mobile, password) => {
    const { data } = await api.post("/auth/login", { mobile, password });
    saveAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const registerMerchant = async (payload) => {
    const { data } = await api.post("/auth/merchant-register", payload);
    saveAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearAuth();
    setUser(null);
  };

  const refreshMe = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("epc_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, registerMerchant, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
